// extracted by mini-css-extract-plugin
module.exports = {"signupContainer":"Signup_signupContainer__AIK4K"};